import { Component, HostListener, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-roaster-plan',
  templateUrl: './roaster-plan.component.html',
  styleUrls: ['./roaster-plan.component.css']
})
export class RoasterPlanComponent implements OnInit {
  bsValue = new Date();
  bsRangeValue: Date[];
  maxDate = new Date();
  minDate = new Date();
  startDate: Date = null;
  endDate: Date = null;
  dateRange: Date[] = [];
  userData: any;
  clientId: any;
  teamList: any;
  page: number = 1;
  pageOption = 7;
  empList:any[]=[];
  form:FormGroup;
  showOptions1 = false;


  constructor(private commonService:CommonService) { 
    this.minDate.setDate(this.minDate.getDate() - 1);
    this.maxDate.setDate(this.maxDate.getDate() + 7);
    this.bsRangeValue = [this.bsValue, this.maxDate];

    this.form = new FormGroup({
      searchValue: new FormControl(''),
      
    });
  }

  ngOnInit(): void {

    let userDataObj = localStorage.getItem('userData');
    if (userDataObj) {
      try {
        this.userData = JSON.parse(userDataObj);
        if(this.userData.attributes.role === 'clients'){
          this.clientId=this.userData.email;
        }
      } catch (error) {

      }
    }

    this.getTeamList();
    this.getEmpList();
  }
  getTeamList(){
    this.commonService.getRequestWithToken(`clientteam/search/${this.clientId}`,[]).then(
        (resp:any) => {
         console.log('teams list=>',resp);
         this.teamList=resp.data;
         console.log(this.teamList)
        },
        (error) => {
          console.error('Error:', error);
         
        }
      );
  }
  getEmpList(){
    this.commonService.getRequestWithToken(`users/clientid/${this.clientId}?role=Employee&team=8`, []).then(
      (resp:any)=>{
        console.log('manager list',resp)
        this.empList=resp.data
      },
      (err)=>{

      }
     )
  }
  generateDateRange() {
    debugger
    if (this.startDate && this.endDate) {
        const startMoment = moment(this.startDate);
        const endMoment = moment(this.endDate);
        const diffDays = endMoment.diff(startMoment, 'days');
        this.dateRange = Array.from({ length: diffDays + 1 }, (_, index) =>
            startMoment.clone().add(index, 'days').toDate()
        ).map(date => new Date(date.getTime() - date.getTimezoneOffset() * 60000));
        console.log('date range', this.dateRange);
    }     
}

  onStartDateChanged(dateString: string) {
    // Parse the dateString to a JavaScript Date object
    const dateParts = dateString.split('-');
    const year = parseInt(dateParts[0]);
    const month = parseInt(dateParts[1]) - 1; // Months are zero-based
    const day = parseInt(dateParts[2]);
    this.startDate = new Date(year, month, day);
    this.generateDateRange();
}

onEndDateChanged(dateString: string) {
    // Parse the dateString to a JavaScript Date object
    const dateParts = dateString.split('-');
    const year = parseInt(dateParts[0]);
    const month = parseInt(dateParts[1]) - 1; // Months are zero-based
    const day = parseInt(dateParts[2]);
    this.endDate = new Date(year, month, day);
    this.generateDateRange();
}
  // Method to show the options
  showOptions() {
    this.showOptions1 = true;
  }

  // Method to hide the options
  @HostListener('document:click')
  hidePopup() {
    this.showOptions1 = false;
  }   
  // Methods for each option
  setLoginLogoutTime() {
    // Logic for Set Login/LogOut Time
  }

  setAsWeekend() {
    // Logic for Set as Weekend
  }

  setAsOnLeave() {
    // Logic for Set as Onleave
  }

  raiseAdhoc() {
    // Logic for Raise Adhoc
  }

  removeRoster() {
    // Logic for Remove Roster
  }

  copyPreviousRoster() {
    // Logic for Copy previous roster
  }

  popupTop: number = 0;
popupLeft: number = 0;

showPopup(index: number, event: MouseEvent) {
  const tdRect = (event.target as HTMLElement).getBoundingClientRect();
  this.popupTop = tdRect.bottom;
  this.popupLeft = tdRect.left;

  this.showOptions1 = true;

  event.stopPropagation(); // Prevents the click event from reaching the document click listener
}
}
